import {Directive, ElementRef} from "@angular/core";
import "materialize-css";

declare var jquery: any;
declare var $: any;

@Directive({
  selector: '[appCarousel]'
})
export class CarouselDirective {
  currentElement: any;

  constructor(private el: ElementRef) {
    this.currentElement = el;
    $(document).ready(function () {
      $('.carousel').carousel({
        fullWidth: true
      });
      $('.arrow-prev').on('click', function () {
        $('.carousel').carousel('prev');
      });
      $('.arrow-next').on('click', function () {
        $('.carousel').carousel('next');
      });
      autoplay()
      function autoplay() {
        $('.carousel').carousel('next');
        setTimeout(autoplay, 7000);
      }
    });
  }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/directives/carousel.directive.ts